import { createTRPCClient, httpBatchLink, TRPCClientError } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'
import type { AppRouter } from '@coneno/c-sheet-server/router'

export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>()

export function createTrpcClient() {
  return createTRPCClient<AppRouter>({
    links: [httpBatchLink({ url: '/api/trpc' })]
  })
}

export function isUnauthorized(error: unknown): boolean {
  return error instanceof TRPCClientError && error.data?.code === 'UNAUTHORIZED'
}

/**
 * True when the API did not answer with a tRPC response at all: the server is down or restarting,
 * or the development proxy could not reach it.
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TRPCClientError) return !error.data
  return error instanceof TypeError
}
